var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup9007(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.629,
    height: 48.183,
    viewBox: "0 0 42.629 48.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "64lgjk86ba",
    x: 0,
    y: 0,
    width: 42.629,
    height: 48.183,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9007"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9005"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29547",
    d: "m1750.788 1257.863-19.584-5.518a.722.722 0 0 1-.5-.889l7.263-25.78a.723.723 0 0 1 .889-.5l19.585 5.518a.722.722 0 0 1 .5.888l-7.263 25.78a.722.722 0 0 1-.89.501z",
    transform: "translate(-1719.444 -1214.832)",
    style: {
      fill: "#3b82f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29548",
    d: "m2453.815 1555.761-9.508-2.679a.534.534 0 0 1-.368-.657.534.534 0 0 1 .657-.368l9.508 2.679a.534.534 0 0 1 .368.657.534.534 0 0 1-.657.368z",
    transform: "translate(-2421.222 -1536.464)",
    style: {
      fill: "#b3cef6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29549",
    d: "m2236.84 1694.917-14.977-4.22a.535.535 0 0 1-.368-.657.535.535 0 0 1 .657-.368l14.977 4.22a.535.535 0 0 1 .369.657.535.535 0 0 1-.658.368z",
    transform: "translate(-2202.353 -1671.867)",
    style: {
      fill: "#b3cef6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29550",
    d: "m2195.444 1841.85-14.977-4.219a.534.534 0 0 1-.368-.657.534.534 0 0 1 .657-.368l14.977 4.22a.535.535 0 0 1 .368.657.534.534 0 0 1-.657.367z",
    transform: "translate(-2161.622 -1816.439)",
    style: {
      fill: "#b3cef6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29551",
    d: "m2154.047 1988.784-14.977-4.22a.534.534 0 0 1-.368-.657.534.534 0 0 1 .657-.368l14.977 4.219a.535.535 0 0 1 .368.657.535.535 0 0 1-.657.369z",
    transform: "translate(-2120.89 -1961.012)",
    style: {
      fill: "#b3cef6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29552",
    d: "m2112.65 2135.717-14.977-4.219a.534.534 0 0 1-.368-.657.535.535 0 0 1 .657-.369l14.977 4.22a.535.535 0 0 1 .368.657.534.534 0 0 1-.657.368z",
    transform: "translate(-2080.158 -2105.584)",
    style: {
      fill: "#b3cef6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29553",
    d: "m2071.254 2282.651-14.977-4.22a.535.535 0 0 1-.368-.657.535.535 0 0 1 .658-.368l14.977 4.22a.534.534 0 0 1 .368.657.535.535 0 0 1-.658.368z",
    transform: "translate(-2039.427 -2250.156)",
    style: {
      fill: "#b3cef6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29554",
    d: "m2029.857 2429.584-14.977-4.22a.534.534 0 0 1-.368-.657.534.534 0 0 1 .657-.369l14.977 4.22a.534.534 0 0 1 .368.657.535.535 0 0 1-.657.369z",
    transform: "translate(-1998.696 -2394.728)",
    style: {
      fill: "#b3cef6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29555",
    d: "m1988.46 2576.518-14.977-4.219a.535.535 0 0 1-.368-.657.534.534 0 0 1 .657-.368l14.977 4.219a.534.534 0 0 1 .368.657.534.534 0 0 1-.657.368z",
    transform: "translate(-1957.964 -2539.301)",
    style: {
      fill: "#b3cef6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29556",
    d: "m1947.064 2723.451-14.977-4.22a.534.534 0 0 1-.368-.657.535.535 0 0 1 .657-.368l14.977 4.22a.534.534 0 0 1 .368.657.535.535 0 0 1-.657.368z",
    transform: "translate(-1917.233 -2683.873)",
    style: {
      fill: "#b3cef6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9006"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#64lgjk86ba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29569",
    d: "m1612.022 1144.682-16.429-1.712a1.172 1.172 0 0 0-1.287 1.044l-2.685 25.758a1.171 1.171 0 0 0 1.044 1.287l19.978 2.082a1.172 1.172 0 0 0 1.287-1.044l2.315-22.209z",
    transform: "translate(-1582.62 -1133.96)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29570",
    d: "M2838.07 1253.467a1.171 1.171 0 0 0 1.044 1.286l3.549.37-4.222-5.205z",
    transform: "translate(-2809.033 -1239.199)",
    style: {
      fill: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29571",
    d: "m2891.991 1548.7 3.67 1 .062-.6z",
    transform: "translate(-2862.094 -1533.175)",
    style: {
      fill: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29572",
    d: "m2094.132 1469.856-10.047-1.047a.5.5 0 0 1-.441-.544.5.5 0 0 1 .544-.441l10.047 1.047a.5.5 0 0 1 .441.544.5.5 0 0 1-.544.441z",
    transform: "translate(-2066.735 -1453.6)",
    style: {
      fill: "#52d1bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29573",
    d: "m1874.833 1657.292-16.609-1.731a.5.5 0 0 1-.441-.544.5.5 0 0 1 .544-.441l16.609 1.731a.5.5 0 0 1 .441.544.5.5 0 0 1-.544.441z",
    transform: "translate(-1844.503 -1637.351)",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29574",
    d: "m1858.571 1813.315-16.609-1.731a.5.5 0 0 1-.441-.544.5.5 0 0 1 .544-.441l16.609 1.731a.5.5 0 0 1 .441.544.5.5 0 0 1-.544.441z",
    transform: "translate(-1828.503 -1790.868)",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29575",
    d: "m1842.309 1969.34-16.609-1.731a.5.5 0 0 1-.441-.544.5.5 0 0 1 .544-.441l16.609 1.731a.5.5 0 0 1 .441.544.5.5 0 0 1-.544.441z",
    transform: "translate(-1812.502 -1944.385)",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29576",
    d: "m1826.047 2125.364-16.609-1.731a.5.5 0 0 1-.441-.544.5.5 0 0 1 .544-.441l16.609 1.731a.5.5 0 0 1 .441.544.5.5 0 0 1-.544.441z",
    transform: "translate(-1796.501 -2097.902)",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29577",
    d: "m1809.784 2281.389-16.609-1.731a.5.5 0 0 1-.441-.544.5.5 0 0 1 .544-.441l16.609 1.731a.5.5 0 0 1 .441.544.5.5 0 0 1-.544.441z",
    transform: "translate(-1780.5 -2251.419)",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29578",
    d: "m1793.522 2437.414-16.609-1.731a.5.5 0 0 1-.441-.544.5.5 0 0 1 .544-.441l16.609 1.731a.5.5 0 0 1 .441.544.5.5 0 0 1-.544.441z",
    transform: "translate(-1764.499 -2404.937)",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29579",
    d: "M2278.4 2670.21a.1.1 0 0 0-.155-.075 1.577 1.577 0 0 1-.283.195l-.148.059q-.147.078-.165-.123a.093.093 0 0 0-.124-.139.631.631 0 0 1-.428.2.531.531 0 0 1-.149-.051.618.618 0 0 0 .093-.087.1.1 0 0 0 .005-.094 1.206 1.206 0 0 0-.1-.194 3.545 3.545 0 0 0 .87-1.368.094.094 0 0 0-.151-.1 2.918 2.918 0 0 0-.848.944.687.687 0 0 0-.106.43c0 .016.008.031.012.046a2.987 2.987 0 0 1-.288.24 1.545 1.545 0 0 1-.441.229c-.115.036-.287.092-.366-.02.261-.146.471-.353.359-.611-.169-.388-.572.2-.593.524a2.146 2.146 0 0 1-.4.135.094.094 0 0 0 .04.183 2.688 2.688 0 0 0 .4-.137c.221.39.92-.009 1.156-.186.07-.053.14-.111.208-.172.054.1.057.08-.076.17a.1.1 0 0 0 .013.172.953.953 0 0 0 .457.135.515.515 0 0 0 .145-.042.092.092 0 0 0 .038.063.771.771 0 0 0 .828-.137 1.246 1.246 0 0 1-.427.76 1.406 1.406 0 0 1-1.219.138c-.116-.023-.177.154-.059.177a1.654 1.654 0 0 0 1.332-.121 1.4 1.4 0 0 0 .57-1.143zm-2.7-.34c.144-.112.046.1 0 .152a.662.662 0 0 1-.109.086.511.511 0 0 1 .109-.238zm1.216-.263a1.383 1.383 0 0 1 .25-.425 2.74 2.74 0 0 1 .333-.367 3.571 3.571 0 0 1-.595.859.617.617 0 0 1 .007-.067z",
    transform: "translate(-2254.942 -2634.899)",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29580",
    d: "M2612.348 2689.2a1.789 1.789 0 1 1 2.047-1.486 1.79 1.79 0 0 1-2.047 1.486zm.5-3.151a1.4 1.4 0 1 0 1.165 1.6 1.4 1.4 0 0 0-1.165-1.604z",
    transform: "translate(-2585.461 -2651.851)",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29581",
    d: "M2670.376 2718.536h-.012a3 3 0 0 0-.425.1l-.2.066-.193.077a5.538 5.538 0 0 0-.734.363 6 6 0 0 0-.677.441 5.991 5.991 0 0 0-.354.282q-.1-.091-.2-.176c-.094-.083-.2-.156-.3-.231a3.2 3.2 0 0 0-.341-.205l-.011-.005a.026.026 0 0 0-.026 0 .026.026 0 0 0-.007.036c.275.4.559.8.843 1.2a.048.048 0 0 0 .067.01q.658-.466 1.306-.947l.649-.479c.218-.158.429-.324.644-.486a.027.027 0 0 0 .01-.025.025.025 0 0 0-.039-.021z",
    transform: "translate(-2640.603 -2684.217)",
    style: {
      fill: "#52d1bd"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9007);
export default __webpack_public_path__ + "static/media/Group9007.5324984db89198e6da9ff1ef27b1c8fb.svg";
export { ForwardRef as ReactComponent };